var currency_mark = "$";
var PROJ = (typeof PROJ === 'object') ? PROJ : {};
PROJ.mixmatch = {
    VAR: {
        back: false,
        color_index_top: 1,
        color_index_bottom: 1,
    },
    init: function () {
        var _this = this;
        var mixandmatch = document.querySelector('.zpro-mm');

        const coin = document.querySelector(".mm-op-color.active").getAttribute("data-num");
        _this.VAR.color_index_top = coin;
        _this.VAR.color_index_bottom = coin;

        //scroll when click scroll to
        document.querySelector(".custom-bikini")?.addEventListener("click", (e) => {
            e.preventDefault();
            document.getElementById("mixmath")?.scrollIntoView({ behavior: "smooth", block: "start" });
        });

        //other scripts
        document.addEventListener('click', function (event) {
            if (event.target.closest('.mm-sum')) {
                event.preventDefault();
                document.getElementById('mixmath')?.classList.toggle('showsum');
            }
            if (event.target.closest('.mobile-mm-nav .top')) {
                event.preventDefault();
                document.querySelector('.vsmm-wrap').scrollIntoView({ behavior: 'smooth' });
                document.getElementById('mixmath')?.classList.remove('showbottom');
            }

            if (event.target.closest('.mobile-mm-nav .bottom')) {
                event.preventDefault();
                document.getElementById('mixmath')?.classList.remove('showsum');
                document.getElementById('mixmath')?.classList.add('showbottom');
                const mmBottom = document.querySelector('.mm-bottom');
                const scrollPosition = mmBottom.getBoundingClientRect().top + window.scrollY - window.innerHeight + mmBottom.offsetHeight + 90;
                window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
            }
        });

        document.querySelectorAll('.color-ar-right, .color-ar-left').forEach(button => {
            button.addEventListener('click', function() {
                let parent = this.closest('.mm-op-list-wrap');
                if (parent) {
                    let scrollContainer = parent.querySelector('.mm-op-list');
                    if (scrollContainer) {
                        let scrollAmount = this.classList.contains('color-ar-right') ? 100 : -100;
                        scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
                    }
                }
            });
        });

        // change colours swatch click
        document.querySelectorAll('.mm-op-color').forEach(function (color) {
            color.addEventListener('click', function (e) {
                e.preventDefault();
                var set = this.closest('[data-mmop]');
                var num = parseInt(this.getAttribute('data-num'));
                var dress_part = set.getAttribute('data-mmop');
                var colection = document.querySelector('.mmcol-' + dress_part);
                var colrhandle = this.getAttribute('data-color-click');
                // document.querySelectorAll('.mm-op-color').forEach()

                set.querySelectorAll('.mm-op-color').forEach(function (child) {
                    child.classList.remove('active');
                });
                this.classList.add('active');
                if (dress_part == 'top') {
                    _this.VAR.color_index_top = num;
                    // console.log(colrhandle);
                } else {
                    _this.VAR.color_index_bottom = num;
                }


                if (colection) {
                    var items = colection.querySelectorAll('[data-quick-add]');

                    items.forEach(function(item) {
                        var data = item.getAttribute('data-quick-add');
                        var parts = data.split(',');

                        if (parts.length >= 2) {
                            parts[1] = colrhandle; // Replace the second part
                            item.setAttribute('data-quick-add', parts.join(','));
                        }
                    });
                }
                PROJ.mixmatch.changeMMURL();

                _this.loadNewColor(colection, num, _this.VAR.back);

                $('.mmbox-' + dress_part + " .colorinput").val($(this).attr('data-value'));

                _this.cartupdate();

            });
        });

        // front back view change
        let fbbtn = document.querySelector('.mm-front-back');
        fbbtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.VAR.back = !_this.VAR.back;
            if (_this.VAR.back) {
                fbbtn.querySelector('.front').classList.remove('active');
                fbbtn.querySelector('.back').classList.add('active');
            } else {
                fbbtn.querySelector('.front').classList.add('active');
                fbbtn.querySelector('.back').classList.remove('active');
            }
            var colection = document.querySelector('.mmcol-top');
            _this.loadNewColor(colection, _this.VAR.color_index_top, _this.VAR.back);
            colection = document.querySelector('.mmcol-bottom');
            _this.loadNewColor(colection, _this.VAR.color_index_bottom, _this.VAR.back);

        });

        //change one property to apply to all other related items in the slider
        var mmwrap = $('.zpro-mm');
        mmwrap.on('change', '.mm-topbot select.pdp-property', function (e) {
            e.preventDefault();

            var set = this.closest('[data-mmop]');
            var dress_part = set.getAttribute('data-mmop');
            var colection = $('.mmcol-' + dress_part);

            var name = $(this).attr('name');
            colection.find('[name="' + name + '"]').val($(this).val());
            var thisVal = $(this).val();
            // console.log(thisVal);

            colection.find('[name="' + name + '"]').each(function () {
                var options = $(this).find('option');
                for (var i = 0; i < options.length; i++) {
                    if (options.eq(i).val() === thisVal) {
                        options.eq(i).attr("selected", "selected");
                    } else {
                        options.eq(i).removeAttr("selected");
                    }
                }
            });
            _this.cartupdate();
        });

        //butt coverage select
        mmwrap.on('click', '.mm-topbot .op-icon', function (e) {
            e.preventDefault();

            var thisset = $(this).parents('.op-wrap');
            thisset.find('.op-icon').removeClass('active');
            $(this).addClass('active');
            thisset.find('.op-input').val($(this).attr('data-value'));

            var set = this.closest('[data-mmop]');
            var dress_part = set.getAttribute('data-mmop');
            var name = thisset.find('.op-input').attr('name');
            var val = thisset.find('.op-input').val();

            var colection = $('.mmcol-' + dress_part);

            colection.find('[name="' + name + '"]').parents('.op-wrap').find('.op-icon').each(function () {
                // console.log($(this).attr('data-value'),"------");
                var options = $(this).find('option');
                if($(this).attr('data-value') == val)
                {
                    $(this).parents('.op-list').find('.op-icon').removeClass('active');
                    $(this).parents('.op-wrap').find('.op-input').val(val);
                    $(this).addClass('active');
                }
            });

            var valname = val.toLowerCase();
            $('[data-custom-img]').attr('data-custom-img','');

            colection.find('[data-cimg-back-' + valname + ']').each(function () {
                $(this).parents('[data-custom-img]').attr('data-custom-img',valname);
            });
            if(_this.VAR.back)
            {
                _this.loadNewColor(document.querySelector('.mmcol-bottom'), _this.VAR.color_index_bottom, 'back');
            }

            _this.cartupdate();

        });

        //add set to cart
        $('body').on('click','#mixmath .mm-add',function(e){
            e.preventDefault();

            if(!$('#mixmath .mm-car').hasClass('active'))
            {
                document.getElementById('mixmath')?.classList.add('showsum', 'sh-error');
                return;
            }

            var items = [];
            $('#mixmath .mm-topbot').each(function(){
                var property = {id: $(this).attr('data-varid'),quantity: 1, properties: {} };

                $($(this).find('.pdp-property:not(.ops-default)')).each(function() {
                    var data1Value = $(this).attr('data-properties');
                    var data2Value = $(this).val();
                    property.properties[data1Value] = data2Value;
                });
                items.push(property);
                console.log(property);
            });

            _this.addMultipleItemsToCart(items);

        });


    }, loadNewColor: function (col, number, back) {
        var selected =  $(col).find('.is-selected [data-cimg-front]');


        var imset = selected.attr('data-cimg-front').split(',');
        if (back)
        {
            imset = selected.attr('data-cimg-back').split(',');
            var imparent =selected.parents('[data-custom-img]');
            var attrname =imparent.attr('data-custom-img')==""?'data-cimg-back':'data-cimg-back-'+imparent.attr('data-custom-img');

            imset = selected.attr(attrname).split(',');
            // console.log(attrname);
        }
        if (imset[number] != "")
        {
            selected.attr('src', imset[number]);
        }

        setTimeout(function(){
        $(col).find('[data-cimg-front]').each(function (num,img) {
            var imset = $(this).attr('data-cimg-front').split(',');
            if (back)
            {
                imset = $(this).attr('data-cimg-back').split(',');
                var imparent = $(this).parents('[data-custom-img]');
                var attrname =imparent.attr('data-custom-img')==""?'data-cimg-back':'data-cimg-back-'+imparent.attr('data-custom-img');

                imset = $(this).attr(attrname).split(',');
                // console.log(attrname);
            }
            if (imset[number] != "")
            {
                $(this).attr('src', imset[number]);
            }
        });},1000);



    }, productChange: function (index, slide) {

        var set = slide == 0 ? 'top' : 'bottom';
        var htmlPlace = document.querySelector('.mm-' + set + " .mm-op-load");
        var htmls = document.querySelector('.body-' + set + ' [data-index="' + index + '"] .mmc-options');
        htmlPlace.innerHTML = htmls.innerHTML;
        this.cartupdate();

    },
    cartupdate: function () {
        var setprice = 0;
        var setcompprice = 0;
        var activeBtn = true;
        $('#mixmath .mm-topbot').each(function () {

            var thisform = $(this);
            var sets = $(this).find('[data-mmop]').attr('data-mmop');

            var optionBox = $('[data-mmop="' + sets + '"].mm-op-box');

            //change product name in all sections
            $('[data-mmop="' + sets + '"] .pr-name').text(optionBox.find('.pr-title').text());

            //change selected items properties in add to cart section

            // console.log(optionBox.find('.mm-var-wrap .variant-data').eq(0).attr('data-id'));

            var formval = "";
            var allselected = true;
            // get options from variant options
            thisform.find('.ops-default').each(function(child) {
                formval += $(this).val();
                if(!$(this).val()) allselected = false;
            });

            //get the selected variant
            var selectedVariant = optionBox.find('.mm-var-wrap .variant-data').eq(0);
            if(allselected)
            {
                thisform.find('.mm-var-wrap .variant-data').each(function(child) {
                    if($(this).attr('data-options') == formval)
                    {
                        selectedVariant = $(this);
                    }
                });
            }

            thisform.find('.op-icon.active').each(function(child) {
                $(this).parents('.op-wrap').find('.op-input').val($(this).attr('data-value'));
            });

            //change product price in all sections
            var price = selectedVariant.attr('data-price');
            var comprice = selectedVariant.attr('data-compare-at-price')?selectedVariant.attr('data-compare-at-price'):0;

            setprice += parseInt(price);
            setcompprice += parseInt(comprice)>0?parseInt(comprice):parseInt(price);

            var compprice_html = comprice>price?"<s>"+currency_mark+(comprice/100).toFixed(2)+"</s>":"";

            // add price to all places
            $('[data-mmop="' + sets + '"] .pricemm').html(compprice_html+" "+ currency_mark+(price/100).toFixed(2));

            //check all options and update
            var productPorperties = "";
            var totalItems = thisform.find('.pdp-property').length;
            thisform.find('.pdp-property').each(function(index, element) {
               if($(this).val())
               {
                   productPorperties += $(this).attr('data-properties') +":<span> "+$(this).val()+"</span>";
               }else
               {
                   activeBtn = false;
                   productPorperties += $(this).attr('data-properties') +":<span class='no'> Please select</span>";
               }
                if (index < totalItems-1 ) {
                    productPorperties += " | ";
                }
               // console.log($(this).attr('data-properties') +":"+$(this).val());
            });

            // console.log("-------");
            var addOptionBox = $('#mixmath [data-mmop="' + sets + '"].mmcart');
            addOptionBox.find('.dataarea').html(productPorperties);
            // mm-var-wrap only
            // console.log(selectedVariant.text(),'----',price);
            thisform.attr('data-varid',selectedVariant.attr('data-id'));

        });

        // add price to cart button
        var setcompprice_html = setcompprice>setprice?"<s>"+currency_mark+(setcompprice/100).toFixed(2)+"</s>":"";
        $('#mixmath .mmprice').html(setcompprice_html+" "+ currency_mark+(setprice/100).toFixed(2));
        activeBtn?$('#mixmath .mm-car').addClass('active'):$('#mixmath .mm-car').removeClass('active');
        activeBtn?document.getElementById('mixmath')?.classList.remove('sh-error'):false    ;

    }

    ,addMultipleItemsToCart:function(items) {
        $('.mm-car').removeClass('active');
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                items: items
            })
        })
            .then(response => response.json())
            .then(data => {
                PROJ.ajaxcart.updateCart();
                setTimeout(function(){$('.mm-car').addClass('active');},1000);

            })
            .catch(error => {
                alert('Error adding items to cart:', error);
            });
    },changeMMURL:function() {
    // Handle .mmcol-top .is-selected [data-quick-add]
    // If body has class 'product', don't run this function
    if (document.body.classList.contains('product')) {
        return;
    }
    var selectedQuickAddTop = document.querySelector('.mmcol-top .is-selected [data-quick-add]');
    var params = new URLSearchParams(window.location.search);

    if (selectedQuickAddTop) {
        var quickAddValueTop = selectedQuickAddTop.getAttribute('data-quick-add');
        if (quickAddValueTop) {
            var partsTop = quickAddValueTop.split(',');
            if (partsTop.length >= 2) {
                params.set('t', partsTop[0]);
                params.set('c', partsTop[1]);
            }
        }
    }

    // Handle .mmcol-bottom .is-selected [data-quick-add]
    var selectedQuickAddBottom = document.querySelector('.mmcol-bottom .is-selected [data-quick-add]');
    if (selectedQuickAddBottom) {
        var quickAddValueBottom = selectedQuickAddBottom.getAttribute('data-quick-add');
        if (quickAddValueBottom) {
            var partsBottom = quickAddValueBottom.split(',');
            if (partsBottom.length >= 1) {
                params.set('b', partsBottom[0]);
            }
        }
    }

    var newUrl = window.location.pathname + '?' + params.toString();
    window.history.replaceState({}, '', newUrl);
    }
}


document.addEventListener('DOMContentLoaded', function () {
    PROJ.mixmatch.init();
});
